import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_BlockSession = {
    access_token: string;
    refresh_token: string;
    dlv_place_cd: string;
};

export const blockSession = (data: I_BlockSession): Promise<I_BlockSession> => {
    return axios.post(`${API_URL_MAIN}/block_session`, data,
    );
};
